const base = (tenantId: string) => `/tenants/${tenantId}/berth-assignment-conditions` as const

export const berthAssignmentConditionsEndpoint = {
  /** 一覧取得（GET）と保存・削除（POST）が共有するリソースルート */
  base,
  detail: (tenantId: string, conditionId: number) => `${base(tenantId)}/${conditionId}` as const,
  selectableFields: (tenantId: string) => `${base(tenantId)}/selectable-fields` as const,
  /** 受付項目の使用有無確認（GET）。`column_name` はクエリで渡す */
  usage: (tenantId: string) => `${base(tenantId)}/usage` as const,
  /** 優先順位の一括更新（PATCH）。全条件 id を希望順で送る */
  priorities: (tenantId: string) => `${base(tenantId)}/priorities` as const,
}
